import { RestRequest } from "@Utils/rest";

export interface IFeatureFlag {
  id: number;
  name: string;
  identifier: string;
  defaultValue: boolean;
}

export interface FeatureFlagOrganization {
  id: number;
  type: "ORGANIZATION";
  organization: { id: number };
  flag: IFeatureFlag;
  value: boolean;
}

export const getFeatureFlags = async () => {
  return RestRequest.get<IFeatureFlag[]>(`api/v1/feature_flags`);
};

export const GetFeatureFlagsOrganization = async () => {
  return RestRequest.get<FeatureFlagOrganization[]>(`api/v1/feature_flag_organizations`);
};

export const createFeatureFlag = async (
  name: string,
  identifier: string,
  defaultValue: boolean = false
) => {
  return RestRequest.post<any, any>("feature_flag", {
    name,
    identifier,
    defaultValue,
  });
};

export const setFeatureFlagForOrganization = async (
  organizationId: number,
  featureFlagId: number,
  value: boolean
) => {
  return RestRequest.post<any, any>("feature_flag_organization", {
    organizationId,
    featureFlagId,
    value,
  });
};
